var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-dialog', {
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c('dialog-default-layout', [_c('template', {
    slot: "title"
  }, [_c('cs-spoiler', {
    attrs: {
      "background": "transparent"
    },
    model: {
      value: _vm.spoilerShown,
      callback: function callback($$v) {
        _vm.spoilerShown = $$v;
      },
      expression: "spoilerShown"
    }
  }, [_c('div', {
    staticClass: "spoiler-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('transfer.for.what')))]), _c('div', {
    staticClass: "modal-help-icon",
    class: {
      'active': _vm.spoilerShown
    }
  })]), _c('div', {
    staticClass: "spoiler-body"
  }, [_c('div', {
    staticClass: "modal-text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product.description.is.important.for.tax.office'))
    }
  })])])])], 1), _c('div', {
    staticClass: "modal-input",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('cs-input', {
    attrs: {
      "error": _vm.error,
      "title": _vm.$t('product.description.default'),
      "display-name": _vm.$t('product.description.default'),
      "placeholder": _vm.$t('for.example.master.class'),
      "required": ""
    },
    on: {
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus
    },
    model: {
      value: _vm.description,
      callback: function callback($$v) {
        _vm.description = $$v;
      },
      expression: "description"
    }
  })], 1), _c('div', {
    staticClass: "modal-button-container",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "modal-button success",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.apply')) + " ")]), _c('button', {
    staticClass: "modal-button cancel",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }